import { Col, Row } from 'antd'
import './TJXItemBreakdownTable.style.less'

type Props = {
  item: any[]
}

function TJXItemBreakdownTable(props: Props) {
  return (
    <div className="tjx-breakdown-table-container">
      <Row className="tjx-item-header-container">
        <Col span={4}>
          <p>TJX Style #</p>
        </Col>
        <Col span={12}>
          <p>Product Description</p>
        </Col>
        <Col span={4}>
          <p>Pack Size</p>
        </Col>
        <Col span={4}>
          <p>Quantity</p>
        </Col>
      </Row>
      {props.item?.map((record) => {
        return (
          <Row key={record.display_order} className="tjx-item-row-container">
            <Col span={4}>
              <p className="bold">{record?.tjxStyle}</p>
            </Col>
            <Col span={12}>
              <p className="bold"> {record?.productDescription}</p>
            </Col>
            <Col span={4}>
              <p className="bold">{record?.packSize}</p>
            </Col>
            <Col span={4}>
              <p>{record?.quantity}</p>
            </Col>
          </Row>
        )
      })}
    </div>
  )
}

export default TJXItemBreakdownTable
